module.exports = "/images/tag_ed880c.png";